"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M12 12.348c2.137 0 4.046.993 5.29 2.542a4.666 4.666 0 0 1 2.014-.455A4.701 4.701 0 0 1 24 19.13a.522.522 0 0 1-1.044 0 3.656 3.656 0 0 0-5.07-3.366 6.74 6.74 0 0 1 .897 3.366.522.522 0 0 1-1.044 0A5.745 5.745 0 0 0 12 13.391a5.745 5.745 0 0 0-5.74 5.74.522.522 0 0 1-1.043 0 6.74 6.74 0 0 1 .896-3.367 3.656 3.656 0 0 0-5.07 3.366.522.522 0 0 1-1.043 0 4.701 4.701 0 0 1 6.71-4.242 6.774 6.774 0 0 1 5.29-2.54ZM4.77 13.39a2.612 2.612 0 0 1-2.609-2.608 2.612 2.612 0 0 1 2.609-2.61 2.612 2.612 0 0 1 2.608 2.61A2.612 2.612 0 0 1 4.77 13.39Zm0-4.174a1.567 1.567 0 0 0 0 3.131 1.567 1.567 0 0 0 0-3.131ZM12 11.304a3.656 3.656 0 0 1-3.652-3.652A3.656 3.656 0 0 1 12 4a3.656 3.656 0 0 1 3.652 3.652A3.656 3.656 0 0 1 12 11.304Zm0-6.26a2.612 2.612 0 0 0-2.609 2.608A2.612 2.612 0 0 0 12 10.261a2.612 2.612 0 0 0 2.609-2.609A2.612 2.612 0 0 0 12 5.043Zm7.304 8.347a2.612 2.612 0 0 1-2.608-2.608 2.612 2.612 0 0 1 2.608-2.61 2.612 2.612 0 0 1 2.609 2.61 2.612 2.612 0 0 1-2.609 2.608Zm0-4.174a1.567 1.567 0 1 0 1.566 1.566c0-.863-.703-1.566-1.566-1.566Z",
    clipRule: "evenodd"
  })]
});